import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react'
import { MinusIcon, PlusIcon } from '@heroicons/react/16/solid'

export default function () {
  return (
    <div className="prose prose-h4:font-semibold prose-h4:text-sm/5 mb-6 max-w-full">
      <h3 className="md:text-h3 text-sm mb-3">Travel FAQs</h3>
      <p>Learn more about important travel requirements.</p>
      <Disclosure as="div" className="pt-0 border-b border-neutral-300">
        <dt>
          <DisclosureButton className="group flex w-full items-start justify-between text-left text-neutral-900 my-4">
            <span className="text-base font-semibold leading-7">General</span>
            <span className="ml-6 flex h-7 items-center">
              <PlusIcon
                aria-hidden="true"
                className="h-6 w-6 group-data-[open]:hidden"
              />
              <MinusIcon
                aria-hidden="true"
                className="h-6 w-6 [.group:not([data-open])_&]:hidden"
              />
            </span>
          </DisclosureButton>
        </dt>
        <DisclosurePanel as="dd" className="my-2 pr-12">
          <div className="m-4">
            <p className="text-sm leading-7 font-semibold">
              Check Passport Expiry
            </p>
            <p className="text-sm leading-7 text-neutral-600">
              Make sure you check your passport expiration dates and apply for a
              new one at least 3 months out from date of travel.
            </p>
          </div>
        </DisclosurePanel>
      </Disclosure>
      <Disclosure as="div" className="pt-0 border-b border-neutral-300">
        <dt>
          <DisclosureButton className="group flex w-full items-start justify-between text-left text-neutral-900 my-4">
            <span className="text-base font-semibold leading-7">
              Destination Planning
            </span>
            <span className="ml-6 flex h-7 items-center">
              <PlusIcon
                aria-hidden="true"
                className="h-6 w-6 group-data-[open]:hidden"
              />
              <MinusIcon
                aria-hidden="true"
                className="h-6 w-6 [.group:not([data-open])_&]:hidden"
              />
            </span>
          </DisclosureButton>
        </dt>
        <DisclosurePanel as="dd" className="my-2 pr-12">
          <div className="m-4">
            <p className="text-sm leading-7 font-semibold">
              Check Visa requirements
            </p>
            <p className="text-sm leading-7 text-neutral-600">
              Make sure you check your passport expiration dates and apply for a
              new one at least 3 months out from date of travel.
            </p>
          </div>
          <div className="m-4">
            <p className="text-sm leading-7 font-semibold">
              Check Smart Traveller
            </p>
            <p className="text-sm leading-7 text-neutral-600">
              Ensure you are up to date on information related to your
              destination such as safety concerns and health requirements. Visit
              <a
                href="https://www.smartraveller.gov.au/"
                target="_blank"
                rel="noreferrer"
              >
                https://www.smartraveller.gov.au/
              </a>
            </p>
          </div>
        </DisclosurePanel>
      </Disclosure>
    </div>
  )
}
